<!-- <div class="row form-group m-form__group">
	<div class="input-group col-sm-12">
		<div class="m-input-icon m-input-icon--left">
			<input type="text" class="form-control m-input m-input--solid" [(ngModel)]="searchtext" (ngModelChange)="search(searchtext)"
			 placeholder="Search by keyword" />
			<span class="m-input-icon__icon m-input-icon__icon--left">
				<span>
					<i class="flaticon-search"></i>
				</span>
			</span>
		</div>
	</div>
</div> -->

<div class="form-group m-form__group row align-items-center">
	<div class="col-12">
		<label for="example_input_full_name" style="font-weight: bold" *ngIf="label">
			{{label}}:
		</label>
		<div class="m-input-icon m-input-icon--left col-12">
			<input type="text" class="form-control m-input m-input--solid notranslate" [(ngModel)]="searchtext" (ngModelChange)="search(searchtext)"
			 placeholder={{placeholder}} />
			<span class="m-input-icon__icon m-input-icon__icon--left">
				<span>
					<i class="flaticon-search"></i>
				</span>
			</span>
		</div>
	</div>
</div>